import { useEffect, useState } from 'react';
import { SectionData } from '../../../survey_engine/SurveyTemplates/Section';
import React from 'react';
import { PageHeader } from '../../../survey_engine/SurveyTemplates/PageHeader';
import { Card } from '../../../../components/Card';
import { SectionList } from '../../../survey_engine/SurveyTemplates/SectionList';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { FIELD_CONFIGS, fetchTemplate } from '../data';
import { NameInput } from '../../../survey_engine/SurveyTemplates/NameInput';
import { SetupPageHeader } from '../../../../components/SetupPageHeader';
import { IconSpan } from '../../../../components/IconSpan';
import {
  appendRedirectUri,
  getRedirectUriQueryParam,
} from '../../../../utils/url';
import { InterviewRatingAlert } from '../InterviewRatingAlert';

interface PropTypes {
  id: number;
}

export default function ShowScorecardTemplatePage(props: PropTypes) {
  const [scorecardTemplate, setScorecardTemplate] = useState({
    name: '',
    default: true,
    sections: [],
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    async function load() {
      const template = await fetchTemplate(props.id.toString());
      setScorecardTemplate(template);
      setIsLoading(false);
    }

    load();
  }, [props.id]);

  return (
    <>
      {isLoading && <LoadingSpinner showBackdrop />}
      <UI
        id={props.id}
        name={scorecardTemplate.name}
        default={scorecardTemplate.default}
        sections={scorecardTemplate.sections}
      />
    </>
  );
}

function UI(props: {
  id: number;
  name: string;
  default: boolean;
  sections: SectionData[];
}) {
  return (
    <div className='container'>
      <PageHeader
        title={props.name}
        backUrl={
          getRedirectUriQueryParam() ??
          '/organization_settings/scorecard_templates'
        }
      />
      <Card>
        <SetupPageHeader
          title='Scorecard'
          firstItems={[]}
          intermediateItems={[
            {
              title: <IconSpan spanText='Edit' icon={{ name: 'bi-pencil' }} />,
              type: 'Navigate',
              action: () =>
                (window.location.href = appendRedirectUri(
                  `/organization_settings/scorecard_templates/${props.id}/edit`,
                )),
              disabled: props.default,
            },
          ]}
        />
        <div className='border-bottom'>
          <div className='d-flex flex-column w-50 fs-5 pt-2 pb-4 gap-4'>
            <NameInput name={props.name} readOnly={true} />
          </div>
        </div>
        <SectionList
          fieldConfigs={FIELD_CONFIGS}
          singleTypeSections={true}
          sections={props.sections}
          readOnly={true}
          title='Sections'
          subtitle='Define and manage your scorecard sections'
          columns={[
            { fieldName: 'type', className: 'col-3' },
            { fieldName: 'text', className: 'col' },
          ]}
        />
        <InterviewRatingAlert />
      </Card>
    </div>
  );
}
